import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d75bb70"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-info" }
const _hoisted_2 = {
  key: 0,
  class: "order-limit-and-service-tags"
}
const _hoisted_3 = {
  key: 1,
  class: "closed-order-span"
}
const _hoisted_4 = { class: "order-detail-container" }
const _hoisted_5 = { class: "date-weekday" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "office-hour-container" }
const _hoisted_8 = { class: "office-hour" }
const _hoisted_9 = { class: "salary-container" }
const _hoisted_10 = { class: "salary" }
const _hoisted_11 = {
  key: 1,
  class: "other-work-time-grid"
}
const _hoisted_12 = {
  key: 0,
  class: "chevron"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.isLink ? 'RouterLink' : 'span'), { to: _ctx.to }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass(["order-item-container", { expired: !_ctx.order.isHiring }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_ctx.isShownTag)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  (!!_ctx.orderTypeLabel)
                    ? (_openBlock(), _createBlock(_component_Tag, {
                        key: 0,
                        variant: "contained",
                        class: "small-tag order-limit-tag",
                        label: _ctx.orderTypeLabel
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  _createVNode(_component_Tag, {
                    variant: "contained",
                    class: "small-tag order-service-tag",
                    label: _ctx.serviceLabel
                  }, null, 8, ["label"]),
                  _createTextVNode(),
                  (!_ctx.order.isHiring)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, "\n              募集終了\n            "))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.date), 1),
                _createTextVNode(),
                _createElementVNode("span", {
                  class: _normalizeClass(["weekday", [{ sun: _ctx.day === 7 }, { sat: _ctx.day === 6 }]])
                }, _toDisplayString(_ctx.dayOfWeek), 3)
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_FeatherIcon, {
                    icon: "clock",
                    size: "16"
                  }),
                  _createTextVNode(" " + _toDisplayString(_ctx.workTime), 1)
                ])
              ]),
              _createTextVNode(),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.salaryPerDayWithVariousAllowancesSign), 1)
              ])
            ]),
            _createTextVNode(),
            (_ctx.hasOtherWorkTimeOption)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, "\n            他の勤務時間も選択可能\n          "))
              : _createCommentVNode("", true)
          ]),
          _createTextVNode(),
          (_ctx.isLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  size: "24",
                  class: "chevron-icon"
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], undefined, true),
    _: 1
  }, 8, ["to"]))
}